export enum OrganizationsPaths {
  Create = 'create',
  Users = 'users',
  Settings = 'settings',
  InviteUsers = 'invite',
  AcceptInvite = 'accept-invite',
}

export enum OrganizationsParams {
  OrganizationId = 'organizationId',
  UserRoleFilter = 'role',
  UserStatusFilter = 'status',
}
